export default "__VITE_ASSET__1ccecad5__"